import { render, staticRenderFns } from "./ConfigAccessStoreGroupModal.vue?vue&type=template&id=66709a53&scoped=true"
import script from "./ConfigAccessStoreGroupModal.vue?vue&type=script&lang=js"
export * from "./ConfigAccessStoreGroupModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigAccessStoreGroupModal.vue?vue&type=style&index=0&id=66709a53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66709a53",
  null
  
)

export default component.exports